import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b1b2fcb8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=b1b2fcb8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1b2fcb8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\chenwllCode\\cunxian\\web-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1b2fcb8')) {
      api.createRecord('b1b2fcb8', component.options)
    } else {
      api.reload('b1b2fcb8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b1b2fcb8&scoped=true", function () {
      api.rerender('b1b2fcb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/distribution/leaderAudit/index.vue"
export default component.exports